import * as rmd from 'material-ui';
import React from 'react';
import TeamPicker from './TeamPicker';
import config from 'cfg';
import moment from 'moment';
import Promise from 'bluebird';

const POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];

class PlayerComparisonPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            homePlayerId: +props.homePlayerId,
            awayPlayerId: +props.awayPlayerId,
            homePlayers: [],
            awayPlayers: []
        };
    }

    componentWillMount() {
        this.handleEventChange(null, this.props.eventId);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.eventId != newProps.eventId) {
            this.handleEventChange(null, newProps.eventId);
        }
    }

    handleEventChange = (key, value) => {
        var eventId = value;
        if (!eventId) return null;

        return fetch(`${config.apis.ss2}/events/${eventId}`)
            .then(response => response.status === 200 && response.json())
            .then(event => {
                return Promise.props({
                    homeId: event.homeId,
                    awayId: event.awayId,
                    homePlayers: fetch(`${config.apis.ss2}/teams/${event.homeId}/members`)
                        .then(response => response.status === 200 && response.json())
                        .then(res => res.players),
                    awayPlayers: fetch(`${config.apis.ss2}/teams/${event.awayId}/members`)
                        .then(response => response.status === 200 && response.json())
                        .then(res => res.players)
                });
            })
            .then(result => this.setState(result));
    };

    renderOption(pl) {
        var text = `${pl.number || ''}. ${pl.name}`;

        return <rmd.MenuItem key={pl.id} value={pl.id} primaryText={text} />;
    }

    render() {
        var homePlayersOptions = _.orderBy(this.state.homePlayers, [
            pl => POSITIONS_ORDER.indexOf(pl.position),
            'number'
        ]);
        var awayPlayersOptions = _.orderBy(this.state.awayPlayers, [
            pl => POSITIONS_ORDER.indexOf(pl.position),
            'number'
        ]);

        //console.log( '--->>', 'PROPS', this.props );

        return (
            <div>
                <rmd.SelectField
                    floatingLabelText="Home team player"
                    value={this.state.homePlayerId}
                    disabled={!this.state.homeId}
                    maxHeight={400}
                    onChange={(e, key, val) =>
                        this.setState({ homePlayerId: val }, () => {
                            this.props.onChange('homePlayerId', val);
                        })
                    }
                >
                    {homePlayersOptions.map(this.renderOption)}
                </rmd.SelectField>
                <rmd.SelectField
                    floatingLabelText="Away team player"
                    value={this.state.awayPlayerId}
                    disabled={!this.state.awayId}
                    maxHeight={400}
                    onChange={(e, key, val) =>
                        this.setState({ awayPlayerId: val }, () => {
                            this.props.onChange('awayPlayerId', val);
                        })
                    }
                >
                    {awayPlayersOptions.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default PlayerComparisonPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/PlayerComparisonPicker.js
 **/